import { defineStore } from 'pinia';

export const useVariantStore = defineStore('variantStore', {
  state: () => ({
    variantsByProductId: {} as Record<string, any>,
    selectedVariantsByProductId: {} as Record<string, any>,
    mandatoryFields: {} as Record<string, any>,
    lastUpdated: {} as Record<string, number>,
  }),
  actions: {
    setVariants(productId: string, variants: any) {
      this.variantsByProductId[productId] = variants;
      this.lastUpdated[productId] = Date.now();
    },
    getVariants(productId: string) {
      return this.variantsByProductId[productId] || [];
    },

     // Set selected variant(s) for a product
    setSelectedVariant(productId: string, variant: any) {
      // const keys = Object.keys(this.selectedVariantsByProductId);
    
      // // If already 5 selected, remove the oldest (first inserted)
      // if (!this.selectedVariantsByProductId[productId] && keys.length >= 5) {
      //   const oldestKey = keys[0];
      //   delete this.selectedVariantsByProductId[oldestKey];
      // }
    
      // Set or update the variant for this product
      this.selectedVariantsByProductId[productId] = variant;
      this.lastUpdated[productId] = Date.now();
    },

    // Get selected variant(s) for a product
    getSelectedVariant(productId: string) {
      return this.selectedVariantsByProductId[productId] || [];
    },

    setMandatoryFields(productId: string, mandatoryFields: any) {
      this.mandatoryFields[productId] = mandatoryFields;
      this.lastUpdated[productId] = Date.now();
    },

    getMandatoryFields(productId: string) {
      return this.mandatoryFields[productId] || [];
    },

    getLastUpdated(productId: string) {
      return this.lastUpdated[productId] || 0;
    },

    clear() {
      this.variantsByProductId = {};
      this.selectedVariantsByProductId = {};
      this.lastUpdated = {};
    },
    clearProduct(productId: string) {
      const lastUpdateTime = this.lastUpdated[productId] || 0;
      const fifteenMinutesInMs = 30 * 60 * 1000; // 15 minutes in milliseconds
      const currentTime = Date.now();

      if (currentTime - lastUpdateTime > fifteenMinutesInMs) {
        delete this.variantsByProductId[productId];
        delete this.selectedVariantsByProductId[productId];
        delete this.mandatoryFields[productId];
        delete this.lastUpdated[productId];
      }
    },

    
  },
  persist: {
    paths: ['variantsByProductId', 'selectedVariantsByProductId', 'lastUpdated']
  } as any
});
